import { Box, Divider, Stack, Typography } from "@mui/material";

import bottomRoutes from "../Router/bottomRoutes";
import routes from "../Router/routes";
import theme from "../theme/theme";
import SidebarMenu from "./SidebarMenu";
import { JevebaraICON } from "../assets/icons";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const CustomDrawer = ({ handleDrawerToggle }: any) => {
  return (
    <Box
      sx={{
        height: "100%",
        backgroundColor: theme.colors.primary,
      }}
    >
      <Stack direction={"row"} justifyContent="flex-start" py={4} pl={4}>
        <JevebaraICON />
        <Box 
          sx={{
              bgcolor:"#B3E2C9",
              opacity:0.8,
              position:"fixed",
              left:240,
              height:"21px",
              width:"21px",
              borderRadius:"100%",
              zIndex:5000,
              display:"flex",
              alignItems: "center",
              justifyContent:"center",
              cursor:"pointer",
              top: 25
            }}
          >
            <ArrowBackIosIcon sx={{color:theme.colors.white,height:'10px',width:"10px"}} />
        </Box>
      </Stack>

      {routes.map((route, index) =>
        route.name !== "subscription" ? (
          <SidebarMenu
            item={route}
            key={index}
            closeDrawer={handleDrawerToggle}
          />
        ) : null
      )}
      <Divider sx={{ my: 2, backgroundColor: "white", mx: 2, ml: 4 }} />
      {bottomRoutes.map((route, index) => (
        <SidebarMenu
          item={route}
          key={index}
          parentTextStyle={{ color: theme.colors.primary, fontSize: 14 }}
          rootStyle={{ marginBottom: 8 }}
        />
      ))}
      <Typography color={'#E7FFE7'} mt={10} fontSize={12} ml={5}>Jevebara copyright 2023 Ⓒ</Typography>
    </Box>
  );
};
export default CustomDrawer;
